import { createStore } from "vuex";
import ISurveyInfo from "@/types/SurveyInfo";

export default createStore({
  state: {
    displayType: "ONE",
    survey_info: {
      displayType: "ONE",
      logoPosition: "WITHOUT",
      surveyEvents: [
        {
          endDate: "",
          event: "",
          startDate: "",
          surveyEventId: 0,
        },
      ],
      surveyId: "",
    },
  },
  getters: {
    GET_DISPLAY_TYPE: (state) => () => {
      return state.displayType;
    },
    GET_SURVEY_INFO: (state) => () => {
      return state.survey_info;
    },
  },
  mutations: {
    SET_DISPLAY_TYPE: (state, displayType: string) => {
      state.displayType = displayType;
    },
    SET_SURVEY_INFO: (state, survey_info: ISurveyInfo) => {
      state.survey_info = survey_info;
    },
  },
  actions: {
    ACTION_SET_DISPLAY_TYPE({ commit }, displayType: string) {
      commit("SET_DISPLAY_TYPE", displayType);
    },
    ACTION_SET_SURVEY_INFO({ commit }, survey_info: ISurveyInfo) {
      commit("SET_DISPLAY_TYPE", survey_info);
    },
  },
  modules: {},
});
